
const {
  bareRequiredContextEntityType,
  requiredContextValueType,
  PRIMITIVE_CONTEXT_TYPES,
} = require("../helpers/required-context-entity-type");

const SOURCE_CONTEXT = "context";
const ENTITY_TYPE_NAME = /^[A-Z][A-Za-z0-9]*$/;

class FeedRowContextGate {


  static needsPrompt({ requiredContexts }) {
    return Object.keys(requiredContexts ?? {}).length > 0;
  }

  static promptRows({ requiredContexts, rowEntityType, contextVarName }) {
    let anchorTaken = false;
    return Object.entries(requiredContexts ?? {}).map(([name, definition]) => {
      const row = FeedRowContextGate.#baseRow(name, definition);
      const { entityType } = row;
      const isAnchor = Boolean(rowEntityType)
        && !anchorTaken
        && entityType === rowEntityType
        && (!contextVarName || name === contextVarName);
      if (isAnchor) {
        anchorTaken = true;
        row.isFeedAnchor = true;
        row.initialData = {
          entityType,
          entitySource: SOURCE_CONTEXT,
          sourceContext: contextVarName ?? name,
        };
      }
      return row;
    });
  }

  static pickerPromptRows(requiredContexts) {
    return Object.entries(requiredContexts ?? {})
        .map(([name, definition]) => FeedRowContextGate.#baseRow(name, definition));
  }

  static #baseRow(name, definition) {
    const valueType = requiredContextValueType(definition);
    const entityType = FeedRowContextGate.#entityTypeOf(definition);
    const row = { name, entityType, appName: definition?.appName ?? null };
    if (valueType && PRIMITIVE_CONTEXT_TYPES.includes(valueType)) {
      row.valueType = valueType;
      return row;
    }
    if (valueType || !ENTITY_TYPE_NAME.test(entityType ?? "")) {
      const declared = valueType ?? definition?.type ?? JSON.stringify(definition ?? null);
      row.unsupportedReason = `Required context "${name}" is a ${declared}, which a feed row cannot source. `
        + `Only an entity or a ${PRIMITIVE_CONTEXT_TYPES.join(", ")} value can be sourced here; `
        + "change the component's required context.";
    }
    return row;
  }

  static #entityTypeOf(definition) {
    return bareRequiredContextEntityType(definition);
  }

}

module.exports = FeedRowContextGate;
module.exports.default = FeedRowContextGate;
